const CONNECTIONS_LOCAL_STORAGE_KEY = 'CONNECTIONS_LOCAL_STORAGE';

export interface Connection {
    nickname: string;
    publicKey: string;
    username: string;
    password: string;
}

export function loadConnections(): Connection[] {
    const saved = window.localStorage.getItem(CONNECTIONS_LOCAL_STORAGE_KEY);
    if (saved) {
        return JSON.parse(saved) as Connection[];
    } else {
        return [];
    }
}

export function saveConnections(connections: Connection[]) {
    window.localStorage.setItem(CONNECTIONS_LOCAL_STORAGE_KEY, JSON.stringify(connections));
}

export function addConnection(connection: Connection): void {
    const connections = loadConnections();
    if (connections.find(c => c.nickname === connection.nickname)) {
        throw new Error(`Connection with nickname "${connection.nickname}" already exists!`);
    }

    connections.push(connection);
    saveConnections(connections);
}

export function deleteConnection(connection: Connection): void {
    const connections = loadConnections();
    const updated = connections.filter(item => item.nickname !== connection.nickname);
    saveConnections(updated);
}
